
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'XingBrands' })
export default class XingBrands extends Vue {}
